import React from 'react';
import PropTypes from 'prop-types';

import { Breadcrumbs } from 'uikit/layouts';

import styles from '../styles/videosBreadCrumbs.module.scss';

const VideosBreadCrumbs = ({ breadcrumbs, shouldShowAllAsActive }) => (
  <Breadcrumbs
    className={styles.breadcrumbs}
    breadcrumbs={breadcrumbs}
    shouldShowAllAsActive={shouldShowAllAsActive}
  />
);

VideosBreadCrumbs.defaultProps = {
  breadcrumbs: [],
  shouldShowAllAsActive: false,
};

VideosBreadCrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({})),
  shouldShowAllAsActive: PropTypes.bool,
};

export default React.memo(VideosBreadCrumbs);
